import React from 'react';
import { Scan, BookOpen, Image, MapPin, Users, Flame } from 'lucide-react';

const AppSection = () => {
  const features = [
    {
      icon: Scan,
      title: 'Descifra los sellos',
      description: 'Descubre códigos ocultos dentro de cada libro de la trilogía',
    },
    {
      icon: Flame,
      title: 'Las Potestades del Infierno',
      description: 'Conoce el origen y los secretos de las Siete Potestades del Infierno',
    },
    {
      icon: Users,
      title: 'Los elegidos y los caídos',
      description: 'Profundiza en la vida de cada personaje del universo',
    },
    {
      icon: BookOpen,
      title: 'Reliquias Arcanas',
      description: 'Explora los artefactos místicos que trascienden las páginas',
    },
    {
      icon: MapPin,
      title: 'Escenarios de la guerra eterna',
      description: 'Descubre los escenarios donde el destino se decide',
    },
    {
      icon: Image,
      title: 'Visiones del universo',
      description: 'Accede a ilustraciones y arte conceptual del universo',
    },
  ];

  return (
    <section id="app" className="reveal relative py-24 px-6 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="section-divider mb-12"></div>

        <div className="text-center mb-16 reveal">
          <h2 className="section-title text-4xl md:text-6xl font-bold mb-6 glow-orange">
            Un Artefacto Arcano
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Esta aplicación no es solo una herramienta.
            <br className="hidden md:block" />
            Es un artefacto arcano diseñado para revelar lo que las páginas no pueden contener.
          </p>
        </div>

        <div className="mb-20 inferno-panel border border-red-900/30 p-8 md:p-12 reveal">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="section-subtitle text-3xl md:text-4xl font-bold mb-6 text-orange-500">
                Desbloquea el Conocimiento Prohibido
              </h3>
              <p className="text-lg text-gray-300 mb-6 leading-relaxed">
                Los símbolos en la página Grimorio dentro de los libros no son simples códigos.
                Son sellos que protegen conocimientos que el mundo olvidó… o decidió ocultar.
              </p>
              <p className="text-base text-gray-400 leading-relaxed">
                Escanea, descubre y adéntrate en las profundidades de un universo donde
                luz y oscuridad están separados por una delgada línea de fuego.
              </p>
            </div>
            <div className="relative flex items-center justify-center min-h-[280px]">
              <div className="logo-core-glow" aria-hidden="true"></div>
              <div className="relative z-10">
                <img
                  src="/logo2.png"
                  alt="App Icon"
                  className="w-64 h-64 mx-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="card-inferno reveal p-8 group cursor-pointer"
              style={{ transitionDelay: `${index * 80}ms` }}
            >
              <feature.icon className="w-12 h-12 text-orange-500 mb-4 group-hover:text-red-500 transition-colors duration-300" />
              <h4 className="text-xl font-bold mb-3 text-white group-hover:text-orange-500 transition-colors duration-300">
                {feature.title}
              </h4>
              <p className="text-gray-400 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-16 reveal">
          <p className="text-lg text-gray-400 mb-6">
            Disponible en Android y como portal web para usuarios de PC y Apple
          </p>
        </div>
      </div>
    </section>
  );
};

export default AppSection;
